<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="top_line"></div>

    <div class="search-header">
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ navbarLang.home }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/cpzy' }">{{ navbarLang.production }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="is-link" @click="$router.go(-1)" style="font-weight:600;color:#000;">{{ productPage.tabs[2] }}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="search-bar">
        <input
          v-model="keyword"
          class="search-input"
          confirm-type="search"
          :placeholder="productPage.placeholderTextOne"
          @keyup.enter="getValue"/>
        <img src="../../assets/images/public/i35.png" @click="getValue" />
      </div>
    </div>
    
    <div class="d_wrap">
      <h2 class="wrap_title">{{ detailsInfo[`${currentLang.prefix}title_desc`] }}</h2>
      <!-- <div class="wrap_one">
        <div>2022-2-15</div>
        <span>常见技术问题</span>
      </div> -->
      <div class="wrap_two article_details" v-html="$convertPxToRem(detailsInfo[`${currentLang.prefix}content`])"></div>


      <div class="wrap_three">
        <template v-if="tapIndex == '' || !isFeedback">
          <span style="margin-right:20px;">{{ detailPage.helpText }}</span>
          <!-- <div v-if="tapIndex !== '' && isFeedback">
            <span :class="['th_no', 'th_none', tapIndex === '1' ? 'th_yes' : '']">
              {{ detailPage.helpYes }}
            </span>
            <span :class="['th_no', 'th_none', tapIndex === '5' ? 'th_yes' : '']">
              {{ detailPage.helpNo }}
            </span>
          </div> -->
          <div>
            <span
              :class="['th_no', tapIndex === '1' ? 'th_yes' : '']"
              @click="changTap('1')"
            >
              {{ detailPage.helpYes }}
            </span>
            <span
              :class="['th_no', tapIndex === '5' ? 'th_yes' : '']"
              @click="changTap('5')"
            >
              {{ detailPage.helpNo }}
            </span>
          </div>
        </template>
        <span class="feedback-tip-txt" v-if="tapIndex == '1' && isFeedback">
          <i class="el-icon-circle-check"></i>
          {{ detailPage.helpSubmitTipTxt }}
        </span>
        <span class="feedback-tip-txt" v-if="tapIndex == '5' && isFeedback">
          <i class="el-icon-circle-check"></i>
          {{ detailPage.helpSubmitTipTxt2 }}
        </span>
      </div>

      <!-- 反馈表单 -->
      <div class="wrap_feedback" v-loading.fullscreen="isFeedbacking" v-if="tapIndex == '5' &&  !isFeedback">
        <span style="margin-right:20px;opacity:0;">{{ detailPage.helpText }}</span>
        <div>
          <!-- 反馈：选择 -->
          <div class="feedback_title feedback_desc">
            {{ detailPage.helpFormTxt.desc }}
          </div>
          <div class="feedback_options">
            <el-radio-group
            v-model="feedbackForm.typename"
            :max="1"
            :min="0"
            :disabled="isFeedback">
              <el-radio
                :label="item.value"
                class="feedback_options-item"
                v-for="(item, i) in detailPage.helpFormTxt.optionList"
                :key="i"
              >
                {{ item.text }}
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 反馈：额外反馈 -->
          <div class="feedback_title feedback_label">
            {{ detailPage.helpFormTxt.feedbackLabel }}
          </div>
          <div class="feedback_textarea">
            <el-input
              type="textarea"
              :autosize="{ minRows: 12, maxRows: 12}"
              placeholder=""
              v-model="feedbackForm.content"
              :disabled="isFeedback">
            </el-input>
          </div>
          <!-- 反馈：提交按钮 -->
          <div class="feedback_submit" :style="{cursor:isFeedback?'no-drop':'pointer'}" @click="handleSubmit">
            <span>{{ detailPage.helpFormTxt.submitTxt }}</span>
          </div>
        </div>
      </div>

      <!-- 返回按钮 -->
      <div style="width:100%;margin:30px 0;display:flex;justify-content:right;border-bottom:1px solid #ccc;">
        <back-button>
          <i slot="prefixIcon"></i>
          {{ productPage.backPreviousPageTxt }}
          <i slot="suffixIcon" class="el-icon-arrow-right"></i>
        </back-button>
      </div>
    </div>

    <div class="wrap_four">
      <h2>{{ detailPage.titleOne }}</h2>
      <p v-html="$convertPxToRem(detailPage.contentOne)"></p>
      <div style="height: 50px;"></div>
      <span style="cursor: pointer;" @click="toCallMe">
        {{ detailPage.callUsBtnText }}
      </span>
    </div>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getProductQuestion, submitProductQuestionFeedback } from "@/utils/http.js";
export default {
  data() {
    return {
      detailsInfo: {},
      tapIndex: "",
      keyword:'',
      feedbackForm: {
        typename: '',
        content: '',
      },
      isFeedback: false,
      isFeedbacking: false,
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    productPage() {
      return this.currentLang.config.productPage
    },
    detailPage() {
      return this.currentLang.config.productPage.detailPage
    },
    navbarLang() {
      return this.currentLang.config.navbar
    }
  },

  mounted() {
    this.getQuestionList();
  },
  methods: {
    getQuestionList() {
      getProductQuestion({
        keyword: this.$route.query.keyword || '',
        page: this.$route.query.page || 1,
        limit: 10,
        title: this.$route.query.activeCate || '',
      }).then(res => {
        console.log(res);
        if (res.code === 1) {
          res.data.list.forEach((item, index) => {
            if (index + "" === this.$route.query.index) {
              this.detailsInfo = item;
            }
          });
        }
      });
    },
    changTap(index) {
      console.log(index);
      this.tapIndex = index;
      if (index == '1') {
        this.handleSubmit()
      }
    },
    toCallMe() {
      this.$router.push("/callMe");
    },
    getValue(){
      this.$router.push({ path: "/cpzy", query: {keyword:this.keyword,index:'3'}})
    },
    toPromble(){
      this.$router.push({ path: "/cpzy", query: {keyword:'',index:'3'}})
    },

    handleSubmit() {
      if (this.isFeedback) return
      this.onSubmitFeedback()
    },
    onSubmitFeedback() {
      this.isFeedbacking = true
      const params = {
        type: this.tapIndex,
        question_id: this.detailsInfo.id ? this.detailsInfo.id : '',
        ...this.feedbackForm
      }
      if (this.tapIndex == '1') {
        params.content = ''
        params.typename = ''
      }
      console.log('params', params)
      submitProductQuestionFeedback(params).then(res => {
        if (res.code == 1) {
          /* this.$message({
            type: 'success',
            message: '提交成功!'
          }); */
          this.isFeedback = true
        }
        else {
          this.$message({
            type: 'error',
            message: res.msg || '提交失败!'
          });
        }
        this.isFeedbacking = false
      }).catch(err => {
        this.isFeedbacking = false
        this.$message({
          type: 'error',
          message: err.msg || '提交失败!'
        });
      })
    }
  }
};
</script>
<style lang="scss" scoped>

.search-header {
  width: 1200px;
  margin: 40px auto;
}

.search-header .search-bar {
  overflow: hidden;
  width: 25%;
  height: 35px;
  border-radius: 25px;
  background-color: white;
  display: flex;
  float: right;
  align-items: center;
  border: 1px solid #B2B2B2;
}

.search-header .search-bar .search-input {
  height: 100%;
  width: 95%;
  margin-left: 10px;
  padding: 0 15px 0 5px;
  border: 0;
  outline: none;
}

.search-bar img {
  width: 15px;
  height: 15px;
  margin-right: 10px;
  cursor: pointer;
}
.top_line {
  width: 100%;
  height: 1px;
  background: #999999;
}
.d_wrap {
  width: 1000px;
  margin: 100px auto 0 auto;
  
  .wrap_title {
    margin-bottom: 30px;
    color: #063358;
    font-weight: 500;
    font-size: 26px;
    letter-spacing: 2px;
    text-align: center;
  }
  .wrap_one {
    display: flex;
    font-size: 16px;
    justify-content: center;
    margin: 20px 0;
    text-align: center;
    div {
      color: #999999;
    }
    span {
      color: #30506f;
      margin-left: 20px;
    }
  }
  .wrap_two {
    font-size: 16px;
    line-height: 1.8;
    // text-indent: 2rem;
    color: #666;
  }
  .wrap_three {
    display: flex;
    width: 1000px;
    color: #656565;
    text-align: left;
    font-size: 16px;
    margin-top: 50px;
    .th_yes {
      padding: 10px 40px;
      line-height: 40px;
      color: #0d3e62;
      border: 1.5px solid #0d3e62;
      background: #c0d6e9;
      border-radius: 10px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }
    .th_no {
      padding: 10px 40px;
      line-height: 40px;
      color: #0d3e62;
      border: 1.5px solid #0d3e62;
      border-radius: 10px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }
    .th_none{
    //   padding: 10px 40px;
    //   line-height: 40px;
    //   color: #0d3e62;
    //   background: gray;
    //   border: 1.5px solid #0d3e62;
    //   border-radius: 10px;
    //   margin: 0 20px;
      cursor: no-drop;
    }

    .feedback-tip-txt {
      width: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 30px;
      background: rgba(103, 194, 58, 0.15);
      border-radius: 12px;
      font-size: 18px;
      font-weight: 500;
      color: #333;

      i {
        font-size: 22px;
        color: #67c23a;
        margin-right:10px;
      }
    }
  }
}


.wrap_feedback {
  display: flex;
  width: 100%;
  margin-top: 30px;
  color: #333;

  .feedback_title {
    margin: 30px 0 0;
    margin-bottom: 10px;
    font-size: 17px;
    font-weight: 500;
    color: #666;
    text-align: left;
  }

  .feedback_desc {
    margin-top: 0;
  }

  /deep/ .el-radio-group {
    display: flex;
    flex-direction: column;
  }

  .feedback_options-item {
    margin-top: 12px;
    color: #000;
    text-align: left;
  }

  /deep/ .el-radio__inner {
    width: 16px;
    height: 16px;
    border-radius: 0;
  }

  /deep/ .el-radio__inner::after {
    content: "√";
    background-color: transparent;
    width: 100%;
    height: 100%;
    color: #fff;
    text-align: center;
  }

  /deep/ .el-radio__label {
    font-size: 16px;
    font-weight: 500;
  }

  .feedback_textarea {
    width: 500px;
    border: 2px solid #ddd;
  }

  /deep/ .el-textarea__inner {
    outline: none;
    resize: none;
    border: 0;
  }

  .feedback_submit {
    margin-top: 20px;
    display: inline-block;
    padding: 8px 20px;
    border: 0;
    border-radius: 8px;
    background-color: var(--main-color-blue);
    color: #fff;
    font-size: 16px;
    letter-spacing: 2px;
    cursor: pointer;
  }
}


.wrap_four {
  width: 100%;
  text-align: center;
  margin-top: 80px;
  padding: 80px 0;
  background: #f5f5f5;

  h2 {
    color: #09395e;
    margin-bottom: 50px;
  }
  p {
    color: #656565;
    margin-top: 10px;
  }
  span {
    padding: 10px 25px;
    border-radius: 5px;
    color: white;
    background: #e8363e;
    cursor: pointer;
  }
}
h2 {
  font-weight: normal;
}
</style>

<style>
.feedback_submit-btn {
  background-color: var(--main-color-blue)!important;
  color: #fff!important;
  border: 0!important;
}


</style>



// WEBPACK FOOTER //
// src/pages/cpzy/detail.vue